import { cloneDeep, PropertyPath, set } from 'lodash';

/**
 * A wrapper around lodash's "set" function
 * it creates all objects in the path if they don't exist
 * @param object - The object to set the property on (will not be mutated)
 * @param path - The path to the property
 * @param value - The value to set
 * @returns A new object with the property set
 */
export function setDeepProperty<T extends object>(object: T, path: PropertyPath, value: any): T {
  object = cloneDeep(object);
  set(object, path, value);
  return object;
}
